import React, { useState } from 'react'
import { IEKGReport } from '../store/ekgImport.types'
import { IonCol, IonGrid, IonIcon, IonItem, IonRow, IonSpinner, IonToggle } from '@ionic/react'
import LabelComponent from '../../../components/label/Label.component'
import { convertImageSizeToKB } from '../../../utilities/ekgImport.util'
import { chevronDown, chevronUp } from 'ionicons/icons'
import './ReportItem.component.css'
import { useDispatch } from 'react-redux'
import { getReportImage } from '../store/ekgImport.actions'
import { useTranslation } from 'react-i18next'
import { IShowPhotoViewerProps } from '../../attachments/page/Attachments.page'
import { PhotoViewer } from '@capacitor-community/photoviewer'

interface IReportItemProps {
  report: IEKGReport
  showToggle?: boolean
  isChecked?: boolean
  handleToggle?: (id: string) => void
}

const ReportItem = (props: IReportItemProps) => {
  const { report, showToggle, isChecked, handleToggle } = props

  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [isExpanded, setIsExpanded] = useState<boolean>(false)

  const onClick = async () => {
    if (!isExpanded) dispatch(getReportImage(report.id))

    setIsExpanded(!isExpanded)
  }

  const showPhotoViewer = (photoViewerProps: IShowPhotoViewerProps) => {
    const { src, alt } = photoViewerProps

    PhotoViewer.show({
      images: [
        {
          url: src || '',
          title: alt,
        },
      ],
      options: {
        share: false,
      },
    })
  }

  const renderReportImage = (imageString: string, alt: string) => {
    const src = `data:image/png;base64, ${imageString}`

    return (
      <div className='report-item-strip-image'>
        <img src={src} alt={alt} onClick={() => showPhotoViewer({ src, alt })} />
      </div>
    )
  }

  const gridClassName = showToggle ? 'event-item-grid' : 'event-item-grid-summary'

  return (
    <IonItem className='event-item'>
      <div className='event-item-main'>
        {showToggle && handleToggle && (
          <IonToggle
            data-testid={`Toggle-${report.id}`}
            slot='start'
            checked={isChecked}
            onClick={() => handleToggle(report.id.toString())}
          />
        )}

        <IonGrid className={gridClassName}>
          <IonRow>
            <IonCol className='data-point event-description-report'>
              <LabelComponent isPHI label={report.description} size={3} />
            </IonCol>
            <IonCol className='data-point event-size'>
              <LabelComponent isPHI label={convertImageSizeToKB(report.imageSize)} size={3} />
            </IonCol>
            <IonCol className='data-point event-more' onClick={onClick}>
              <IonIcon color='medium' className='event-more-icon' icon={isExpanded ? chevronUp : chevronDown} />
            </IonCol>
          </IonRow>
        </IonGrid>
      </div>
      {isExpanded && (
        <div className='report-item-strip'>
          {report?.image?.imageString ? (
            <>{renderReportImage(report.image.imageString, report.description)}</>
          ) : (
            <>
              {report?.image?.isUnavailable ? (
                <div className='report-item-strip-no-image'>{t('ekg.previewUnavailable')}</div>
              ) : (
                <IonSpinner />
              )}
            </>
          )}
        </div>
      )}
    </IonItem>
  )
}

export default ReportItem
